import AnesthetistInsuranceCardFormContainer from './AnesthetistInsuranceCardFormContainer';

export default AnesthetistInsuranceCardFormContainer;